module.exports = __webpack_public_path__ + "img/0012_darkred.24baa7d6.jpg";